import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "layout" }
const _hoisted_5 = { class: "sidebar sidebar-layer" }
const _hoisted_6 = { class: "main main-layer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderNav = _resolveComponent("HeaderNav")!
  const _component_ProfilePanel = _resolveComponent("ProfilePanel")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "page-bg",
      src: _ctx.backgroundSrc,
      alt: "",
      referrerpolicy: "no-referrer"
    }, null, 8, _hoisted_2),
    _createVNode(_component_HeaderNav, { class: "header-layer" }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("aside", _hoisted_5, [
          _createVNode(_component_ProfilePanel)
        ]),
        _createElementVNode("main", _hoisted_6, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_Transition, {
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("footer", { class: "site-footer" }, [
      _createElementVNode("p", { class: "footer-line" }, [
        _createTextVNode(" © 2026 · Powered by "),
        _createElementVNode("a", {
          class: "author-link",
          href: "https://space.bilibili.com/15278628",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "白曙Shiroake")
      ]),
      _createElementVNode("p", { class: "footer-line footer-disclaimer" }, " 本站为爱好者作品，和官方没有关联 ")
    ], -1))
  ]))
}